import { selectLocationSwitcherData } from 'shared/selectors/geo';
import { setLocation } from 'shared/slices/location';
import { TThunkAction } from 'shared/types/redux';

export const applyLocationSwitcherSelection = (): TThunkAction => (dispatch, getState) => {
  const state = getState();
  const { selectedCity, selectedRegion } = selectLocationSwitcherData(state);
  const nextLocation = selectedCity || selectedRegion;

  if (nextLocation) {
    dispatch(setLocation(nextLocation));
  }
};
